<template>
    <div class="study-detail">
        <div class="video-box">
            <a href="javascript:history.go(-1);" class="back" v-if="isZgapp && isApp || !isZgapp && isIos || !isZgapp && isAndroid">
                <i class="el-icon-arrow-left"></i>
            </a>
            <div :class="{'fixed': isFixed}">
                <Video :lesson="lesson"></Video>
            </div>
        </div>
        <div class="J_courseList">
            <div class="study-detail-info">
                <Message :msg="lesson"></Message>
                <StudyList @send="getNewLesson" :list="list" v-if="isData"></StudyList>
                <div class="no-class-data" v-if="isNoData" v-show="isTip">
                    <p>
                        <img src="../../../assets/images/no_data.png" alt=""/>
                    </p>
                    <p>该课程暂时还没有其他关联课程哦</p>
                </div>
            </div>
            <OtherList @sendOther="getNewLesson" :list="otherList"></OtherList>
        </div>
        <Loading :show="isUa && isLoading"></Loading>
    </div>
</template>

<script>
import jsonp from 'jsonp';
import Video from "../video"
import Message from './module/message'
import OtherList from './module/otherList'
import StudyList from './module/studyList'
import Loading from "../../loading"
import util from '../../../util'

export default{
    name: 'StudyDetail',
    data(){
        return{
            id: '',
            isLoading: false,
            isUa: false,
            isFixed: false,
            lesson: {},
            isData: false,
            isNoData: false,
            name: this.$route.params.name,
            sortid: this.$route.params.sortid,
            list: [],
            otherList: [],
            isZgapp: window.navigator.userAgent.indexOf('ZgApp') >= 0,
            isAndroid: window.navigator.userAgent.indexOf('Android') >= 0,
            isIos: !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        }
    },
    created(){
        this.getContent();
        this.getData(this.name);
    },
    mounted () {
        util.jumpLink();
        this.$nextTick(() => {
            if(this.isPhone()){
                window.addEventListener("scroll", () => {
                    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                    this.isFixed = scrollTop > 200 && this.video !== null;
                });
            }
        });
    },
    computed:{
        isTip(){
            return this.lesson.title.indexOf('预告') < 0
        }
    },
    methods:{
        getNewLesson(lesson){
            this.lesson = lesson;
        },
        getData(name){
            let idArr = [];
            // switch(name){
            //     case '小学教育':
            //         idArr = [50946,50947,50948,50949,50950,50951].join(',');
            //         break;
            //     case '初中教育':
            //         idArr = [50952,50953,50954].join(',');
            //         break;
            //     case '高中教育':
            //         idArr = [50955,50956,50957].join(',');
            //         break;
            //     default:
            //         idArr = this.sortid
            //         break;
            // }
            this.axios.get(`/data/${this.sortid}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                let courseList = res.data.courselist;
                this.isLoading = false;
                this.isData = courseList.filter(item => item.title.indexOf(this.name) >= 0).length > 0 ? true : false;
                this.isNoData = courseList.filter(item => item.title.indexOf(this.name) >= 0).length === 0 ? true : false;
                let classList = courseList.filter(item => item.title.indexOf(this.name) >= 0);
                this.list = courseList ? this.getTraverse(classList) : [];
                let otherList = this.list.length === 0 ? courseList.filter(item => item.articleid !== this.$route.params.id) : courseList.filter(item => item.title.indexOf(this.name) < 0);
                this.otherList = courseList ? this.getTraverse(otherList) : []
            })
            // jsonp(`https://v.gxnews.com.cn/?c=json&a=course_list&sortids=${idArr}&limit=100&k=${this.name}`, {} , (err, data) => {
            //     if (err) {
            //         console.error(err.message);
            //     } else {
            //         this.isData = data.courselist.length > 0 ? true : false;
            //         this.isNoData = data.courselist.length === 0 ? true : false;
            //         this.list = data.courselist ? data.courselist.map(item => {
            //             return{
            //                 id: item.articleid,
            //                 url: item.playurl,
            //                 author: item.author,
            //                 title: item.title,
            //                 poster: item.img,
            //                 source: item.source,
            //                 date_ymdhis: item.date_ymdhis,
            //                 videodurationstr: item.videodurationstr
            //             }
            //         }) : [];
            //     }
            // })
        },
        getTraverse(list){
            let newList = list.map(item => {
                return{
                    id: item.articleid,
                    url: item.playurl,
                    author: item.author,
                    title: item.title,
                    poster: item.img,
                    sortid: item.sortid,
                    source: item.source,
                    date_ymdhis: item.date_ymdhis,
                    videodurationstr: item.videodurationstr
                }
            })
            return newList
        },
        getContent(){
            this.isLoading = true;
            this.axios.get(`/data/${this.$route.params.sortid}.json?t=${Math.round(new Date().getTime()/100000)}`).then((res) => {
                this.isLoading = false;
                res.data.courselist.map(item => {
                    if(item.articleid == this.$route.params.id){
                        this.lesson = {
                            id: item.articleid,
                            url: item.playurl,
                            author: item.author,
                            title: item.title, 
                            source: item.source,
                            sortid: item.sortid,
                            poster:item.img,
                            date_ymdhis: item.date_ymdhis  
                        }   
                    }
                });
                let pvSortid = this.$route.params.sortid ? this.$route.params.sortid : '';
                let myurl = `http%3a%2f%2fbyte.gxnews.com.cn%2fzg%2f%23%2fstudyDetail/${encodeURI(this.$route.params.name)}/${this.lesson.id}/${pvSortid}`;
                document.title = this.lesson.title;
                jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=${myurl}&sid=${pvSortid}&aid=${this.lesson.id}&tag=zgapp&t=${Math.random()}`, {} , (err, data) => {
                    if (err) {
                        console.error(err.message);
                    } else {
                        console.log('请求成功');
                    }
                })
            })
        },
        isPhone(){
            let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return mobile!= null
        }
    },
    components:{
        Video,
        Message,
        OtherList,
        StudyList,
        Loading
    },
}
</script>

<style lang="less" scoped>
    .video-box{
        position: relative;
        background: url("../../../assets/images/detail_bg.jpg") no-repeat;
        background-size: 100%;
        padding: 25% 0.3rem 0 0.3rem;
        .back{
            border-radius: 50%;
            background: rgba(0,0,0,0.2);
            display: block;
            position: absolute;
            left: 0.5rem;
            top: 0.5rem;
            z-index: 10;
            color: #fff;
            width: 0.7rem;
            height: 0.7rem;
            line-height: 0.7rem;
            text-align: center;
            font-size: 0.5rem;
        }
        i{
            font-weight: bold;
        }
    }
    .study-detail-info{
        padding: 0.3rem 0 0.45rem 0;
        border-bottom: 0.2rem solid #f3f3f3;
    } 
    .no-class-data{
        text-align: center;
        p{
            margin-bottom: 0.25rem;
            font-size: 0.26rem;
            color: #888;
        }
        img{
            width: 12%;
        }
    }             
</style>   